import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  RM_TICKET,
  RM_TICKET_REPORT,
  RM_TICKET_DETAILS,
  RM_STATUS,
  RM_TICKET_FILTER,
  GET_MATERIAL,
  GET_EQUIPMENT, RM_TICKET_DETAILS_FOR_UPDATION,
  RM_TICKET_DETAILS_SLOT
} from './type';

export const fetchRmTicket = (filterData = null, page = 1, filterFlag = false) => async (
  dispatch
) => {
  dispatch({
    type: RM_TICKET,
    payload: null,
  });
  console.log(filterData)
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.maintenance.rmList}?page=${page}`
      : `${Config.maintenance.rmList}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&fd_ticket_id=${filterData.fd_ticket_id}&fusion_ticket_id=${filterData.fusion_ticket_id}&city_id=${filterData.city_id}&page=${page}&flag=${filterFlag}&complain_id=${filterData.complain_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchRmTicketDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.viewRmList}?rm_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const postUpdateRMStatus = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.rmUpdateStatus}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postTicketAssignment = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.rmAssignment}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const postRmRemark = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.postRmRemark}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};
export const getMaterial = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getRMMaterial}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_MATERIAL,
      payload: data.response.data,
    });
    return true;
  }
};

export const getEquipments = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getEquipment}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_EQUIPMENT,
      payload: data.response.data,
    });
    return true;
  }
}; 


export const fetchRmTicketStatus = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.rmStatus}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_STATUS,
      payload: data.response.data,
    });
    return true;
  }
};

export const getRmTicketsFilterDropDown = (filterStatusCheck = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.rmTicketsFilters}?filterStatusCheck=${filterStatusCheck}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchRmTicketReport = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({
    type: RM_TICKET_REPORT,
    payload: null,
  });
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.maintenance.rmListReport}?page=${page}`
      : `${Config.maintenance.rmListReport}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET_REPORT,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchRmTicketDetailsForUpdation = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.viewRmList}?rm_ticket_id=${id}&is_update=1`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET_DETAILS_FOR_UPDATION,
      payload: data.response.data,
    });
    return true;
  }
};

export const postUpdateRca = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.rmUpdateRca}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const fetchRmTicketDetailsForSlotChange = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.viewRmListForSlotChange}?rm_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: RM_TICKET_DETAILS_SLOT,
      payload: data.response.data,
    });
    return true;
  }
};

export const postTicketChangeSlot = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.ticketChangeSlot}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const generateHappyCode = (status,ticket_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.generateHappyCode}?rm_ticket_id=${ticket_id}&status=${status}`
  );
  if (res) {
    return true;
  }
};